export default __webpack_public_path__ + "static/media/android.ba32835a.png";